import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useToast } from './ToastContext';

const ProcessedTimesheetContext = createContext();

export const useProcessedTimesheetContext = () => {
    const context = useContext(ProcessedTimesheetContext);
    if (!context) {
        throw new Error(
            'useProcessedTimesheetContext must be used within a ProcessedTimesheetContextProvider'
        );
    }
    return context;
};

export const ProcessedTimesheetContextProvider = ({ children }) => {
    const [hasRecentChanges, setHasRecentChanges] = useState(false);
    const { showErrorToast } = useToast();

    const handleOutdatedError = useCallback((apiError, errorCb) => {
        if (apiError?.errorCode === 422) {
            setHasRecentChanges(true);
            showErrorToast(
                'This transaction has been updated, and your changes cannot be saved. Please refresh the page to see the latest values. Any unsaved changes will be lost after refreshing.'
            );
        } else {
            errorCb?.(apiError);
        }
    }, []);

    const contextValue = useMemo(
        () => ({ hasRecentChanges, setHasRecentChanges, handleOutdatedError }),
        [hasRecentChanges, setHasRecentChanges, handleOutdatedError]
    );

    return (
        <ProcessedTimesheetContext.Provider value={contextValue}>
            {children}
        </ProcessedTimesheetContext.Provider>
    );
};
